import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import SEO from "@/components/SEO";

// Lazy-load below-the-fold sections to reduce the initial JS bundle.
// Hero is critical (LCP), but everything below can be fetched on demand.
const MarketplaceSection = lazy(() => import("@/components/MarketplaceSection"));
const GallerySection = lazy(() => import("@/components/GallerySection"));
const ProcessSection = lazy(() => import("@/components/ProcessSection"));
const CtaSection = lazy(() => import("@/components/CtaSection"));
const FooterSection = lazy(() => import("@/components/FooterSection"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Retratos Pop Art de Mascotas en México | PAWTRAiT"
        description="Convierte la foto de tu perro o gato en arte pop único. Lienzos pintados a mano y merch personalizado (playeras, tazas, totes). Envíos a todo México desde $350 MXN."
        path="/"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "PAWTRAiT",
            url: "https://pawtraitpop.art",
            inLanguage: "es-MX",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://pawtraitpop.art/merch-digital?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          },
          {
            "@context": "https://schema.org",
            "@type": "Store",
            name: "PAWTRAiT",
            image: "https://pawtraitpop.art/favicon.ico",
            url: "https://pawtraitpop.art",
            telephone: "+52-55-1820-3213",
            priceRange: "$350 - $4500 MXN",
            areaServed: { "@type": "Country", name: "México" },
            address: { "@type": "PostalAddress", addressCountry: "MX" },
            description: "Retratos pop art personalizados de mascotas: lienzos pintados a mano y merch digital impreso bajo demanda.",
            sameAs: ["https://www.instagram.com/pawtrait.pop"],
          },
          {
            "@context": "https://schema.org",
            "@type": "Service",
            serviceType: "Retrato pop art personalizado de mascotas",
            provider: { "@type": "Organization", name: "PAWTRAiT" },
            areaServed: "MX",
            offers: {
              "@type": "AggregateOffer",
              priceCurrency: "MXN",
              lowPrice: "350",
              highPrice: "4500",
              availability: "https://schema.org/InStock",
            },
          },
        ]}
      />
      <Navbar />
      <HeroSection />
      <Suspense fallback={null}>
        <ProcessSection />
        <MarketplaceSection />
        <GallerySection />
        <CtaSection />
        <FooterSection />
      </Suspense>
    </div>
  );
};

export default Index;
